import type { QuestionTracker } from "@shikaku/shared";

interface BookmarkButtonProps {
  tracker: QuestionTracker;
  questionId: string;
  accentColor: string;
}

export function BookmarkButton({ tracker, questionId }: BookmarkButtonProps) {
  const isBookmarked = tracker.isBookmarked(questionId);

  return (
    <button
      onClick={() => tracker.toggleBookmark(questionId)}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        width: "100%",
        padding: "12px",
        background: isBookmarked ? "#fff8f0" : "#fff",
        border: `2px solid ${isBookmarked ? "#f0a030" : "#e0e0e0"}`,
        borderRadius: 8,
        cursor: "pointer",
        fontSize: 14,
        fontWeight: 600,
        color: isBookmarked ? "#f0a030" : "#888",
        transition: "all 0.15s",
      }}
    >
      <svg
        width="16" height="16"
        fill={isBookmarked ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth={2}
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
      </svg>
      {isBookmarked ? "ブックマーク済み" : "ブックマークする"}
    </button>
  );
}
